import { GraphQLClient } from 'graphql-request'

import { config, isProxy } from '../../../config'
import { getExposedCredentials } from '../../localStorage/authentication'

const apiURL = config.apiGateway.formalizationApiUrl as string
export const formalizationAPI = new GraphQLClient(apiURL)

export function setupFormalizationAPI(): void {
  if (isProxy()) {
    return
  }
  const { accessToken } = getExposedCredentials()

  if (accessToken) {
    formalizationAPI.setHeader('Authorization', `Bearer ${accessToken}`)
  }
}
